/* eslint-env browser, amd */
/* eslint no-unused-vars: "off" */
/* eslint no-multi-spaces: "off" */
'use strict';

define(function (require, exports, module) {
    require('./header');

    var bamHbsClientUtils = require('bam-handlebars-helpers/utils/client');
    var bamHbsHelpers = require('bam-handlebars-helpers/index');
    var dialogPolyfill = require('dialog-polyfill/dialog-polyfill');
    var doubleclick = require('doubleclick/gpt');

    var MlbLinker = require('mlb-linker/dist/index.bundle');
    var MilbMomentTimezoneWrapper = require('milb-moment-timezone-wrapper/dist/index.bundle');
    var pageMeta = require('pageMeta/pageMeta');
    var spriteMapLoader = require('./bam-sprite-loader');
    var appearsExpires = require('./appearsExpires');

    require('./browser-nag');
    require('./footer');
    require('./search');
    require('./tracking-async');

    // require('./tracking');
    // require('tickets-tfl-tracking/tfl-tracking');

    var appView = pageMeta.appView || 'web';
    var club = pageMeta.club || 'milb';
    var deviceDesktop = window.deviceBootstrap().formFactor || 'desktop';
    var env = pageMeta.env || 'production';
    var fileCode = pageMeta.fileCode || 'milb';
    var locale = pageMeta.locale || 'en';
    var tz = pageMeta.timezone || 'America/New_York';
    var siteCoreLoc = pageMeta.siteCoreLocation || '';
    var teamSlugs = window.MilbUtils && window.MilbUtils.teamIdToSlugMap;
    var baseUrl = window.isMlbPartner ? 'https://www.mlb.com' : '';

    if (deviceDesktop) {
        var skinRandomizer = require('./skin-randomizer');
    }

    const urlParams = new URLSearchParams(window.location.search);
    const vsmDate = urlParams.get('vsmDate');
    if (vsmDate) {
        let vsmTime;
        if (/^\d+$/.test(vsmDate)) {
            vsmTime = parseInt(vsmDate, 10) * 1000;
        } else {
            vsmTime = Date.parse(vsmDate);
        }
        Date.now = function now() {
            return vsmTime;
        };
    }

    // get wiremock params and store on window
    const wiremockParams = urlParams.get('wiremock');
    if (wiremockParams) {
        const wiremockPaths = {};
        wiremockParams.split(',').forEach((item) => {
            const [component, path] = item.split(':');
            wiremockPaths[component] = path;
        });
        window.wiremockPaths = wiremockPaths;
    }

    window.milbDoubleclick = doubleclick;
    window.milbMoment = new MilbMomentTimezoneWrapper(locale, tz);
    window.milbLinker = new MlbLinker(window, {
        isMilb: true,
        teamSlugs,
        baseUrl,
        isMlbPartner: window.isMlbPartner,
    });
    window.pageMeta = pageMeta;
    window.baseUrl = baseUrl;

    if (window.isMlbPartner) {
        // open all links in new tab on partner sites
        const setTargetBlank = () => {
            $('a').attr('target', '_blank');
        };
        setTargetBlank();
        const observer = new MutationObserver(setTargetBlank);
        const mlbPartnerContainer = document.querySelector('.isMlbPartner');
        observer.observe(mlbPartnerContainer, {
            childList: true,
            subtree: true,
        });
    }

    // Register base handlebars helpers.
    bamHbsClientUtils.registerHelpers(bamHbsHelpers.helpers);

    // Load icons
    spriteMapLoader(siteCoreLoc + '/images/icons/icons.svg');

    try {
        var interstitialSlotRenderedHandler = $.noop();
        var interstitialModal = document.querySelector('.p-ad--interstitial');
        if (interstitialModal) {
            dialogPolyfill.registerDialog(interstitialModal);

            var interstitialCloseHandler = function () {
                clearInterval(window.interstitialSecondsInterval);
            };

            interstitialModal.querySelector('.p-modal__close').onclick =
                function () {
                    interstitialModal.close();
                };

            interstitialModal.addEventListener(
                'close',
                interstitialCloseHandler,
            );
            interstitialModal.addEventListener(
                'cancel',
                interstitialCloseHandler,
            );

            interstitialSlotRenderedHandler = function (adSlotEvent) {
                //exit early for non-interstitial ad slots
                if (
                    adSlotEvent.slot.getSlotElementId() !==
                    'ad-1x2-interstitial'
                ) {
                    return;
                }

                // handle a populated interstitial ad slot
                if (!adSlotEvent.isEmpty) {
                    var interstitialSecondsDuration = 11;
                    var interstitialSecondsContainer = document.getElementById(
                        'p-ad-interstitial__seconds',
                    );
                    var interstitialMessage =
                        'Advertisement will run for @seconds@ second';

                    window.interstitialSecondsInterval = setInterval(
                        function () {
                            if (interstitialSecondsDuration === 1) {
                                interstitialModal.close();
                            }

                            var update = interstitialMessage;
                            if (--interstitialSecondsDuration > 1) {
                                update += 's';
                            }
                            interstitialSecondsContainer.innerHTML =
                                update.replace(
                                    /@seconds@/gi,
                                    interstitialSecondsDuration,
                                );
                        },
                        1000,
                    );

                    interstitialModal.showModal();
                }
            };
        }

        // Ad Unit Logic and Set up for both AdOps and 33Across served ads by AdOps here:
        var adUnitHierarchy1 = 'MiLB.com';
        if (pageMeta['team-id'] && pageMeta['team-id'] !== 'milb') {
            adUnitHierarchy1 = 't' + pageMeta['team-id'] + '.milb';
        } else if (pageMeta['league-id']) {
            adUnitHierarchy1 = 'l' + pageMeta['league-id'] + '.milb';
        }
        var adUnitHierarchy2 = '/' + pageMeta.page_section;

        window.pageMeta.adUnitHierarchy1 = adUnitHierarchy1;
        window.pageMeta.adUnitHierarchy2 = adUnitHierarchy2;

        window.milbDoubleclick.siteCoreConfig({
            adUnitHierarchy1: adUnitHierarchy1,
            adUnitHierarchy2: adUnitHierarchy2,
            thresholdsMap: ['xs', 's', 'm', 'l', 'xl'],
            thresholds: [0, 568, 768, 1024, 1304],
            appView: appView,
            skinElement: 'main',
            responsive: true,
            targeting: {
                locale: locale,
                devicetype: deviceDesktop,
                env: env,
                pathname: window.location.pathname.split('/').splice(1),
                pageid: window.pageMeta.club || 'milb',
            },
            slotRenderedHandler: interstitialSlotRenderedHandler,
        });
    } catch (error) {
        console.log('ad error');
        console.log(error);
    }

    // /Ad
    appearsExpires('data-pb-appears', 'data-pb-expires');
});
